import lowercaseFormatDuration from 'owa-duration-formatter/lib/lowercase';
import EventDurationOption from '../data/store/schema/EventDurationOption';

const SECONDS_IN_MINUTE = 60;
const eventOptions: EventDurationOption[] = [
    { key: 15, text: '' }, // 15 minutes
    { key: 25, text: '' }, // 25 minutes
    { key: 30, text: '' }, // 30 minutes
    { key: 45, text: '' }, // 45 minutes
    { key: 55, text: '' }, // 55 minutes
    { key: 60, text: '' }, // 1 hour
];

/* Check if the selected duration exists in the dropdown.
 * If not present, then add the custom event duration.
 * This can happen when a user chooses the custom option in event duration settings (JSMVVM) and moves to React.
 */
export default function createEventDurationDropdownOptions(
    selectedDuration: number
): EventDurationOption[] {
    let eventDropdownOptions: EventDurationOption[] = [];
    eventOptions.forEach(option => {
        let newOption: EventDurationOption = {
            key: option.key,
            text: lowercaseFormatDuration(option.key * SECONDS_IN_MINUTE),
        };
        eventDropdownOptions.push(newOption);
    });

    if (!isSelectedDurationPresent(eventDropdownOptions, selectedDuration)) {
        eventDropdownOptions.push({
            key: selectedDuration,
            text: lowercaseFormatDuration(selectedDuration * SECONDS_IN_MINUTE),
        });
        eventDropdownOptions.sort((a, b) => a.key - b.key);
    }
    return eventDropdownOptions;
}

function isSelectedDurationPresent(
    eventDropdownOptions: EventDurationOption[],
    selectedDuration: number
): boolean {
    let selectedOptionPresent = false;
    for (let i = 0; i < eventDropdownOptions.length; i++) {
        if (eventDropdownOptions[i].key == selectedDuration) {
            selectedOptionPresent = true;
            break;
        }
    }
    return selectedOptionPresent;
}
